import OrderDetailsData from "@/app/components/orderDetails/OrderDetailsData";
import { useSelector } from "react-redux";
import Error404Page from "../errors/404";
import { RootState } from "@/app/store/store";

const OrderDetailsPage = () => {
    const isAuthenticated = useSelector(
      (state: RootState) => state.userState.isAuthenticated
    );
    
    if (!isAuthenticated) {
      return <Error404Page />;
    }
    
  return <OrderDetailsData />;
};

export default OrderDetailsPage;
